// ─── Aviso de seguridad: cambio de contraseña forzado en caliente ───────────
// Cuando un administrador fuerza o restablece la contraseña de alguien, la
// Edge Function admin-usuarios inserta una fila en avisos_usuario. Si ese
// alguien tiene el panel ABIERTO, este módulo la recibe por realtime y muestra
// una alerta pequeña con una cuenta regresiva de 3 minutos; al llegar a cero
// cierra la sesión, para que vuelva a entrar y el cambio obligatorio lo
// detenga en la puerta. Los 3 minutos son para terminar y guardar lo que esté
// haciendo — no para seguir trabajando.
//
// La tarjeta vive fuera de #root (render() la barrería) y se coloca en la
// esquina compartida de avisos (ver ui/dock.js), que la ordena por urgencia
// para que ningún otro aviso la tape.
import { anotarSalida } from "../core/auditLog.js";
import { PRIORIDAD, anclarConEntrada } from "./dock.js";
import { vaciarSincronizacionPendiente } from "../core/cloudSync.js";
import { C } from "../core/config.js";
import { supa } from "../core/supabaseClient.js";

const CUENTA_MS = 3 * 60 * 1000;

let __inicioSesion = null;   // los avisos anteriores al login ya se atendieron en la puerta

export function iniciarAvisosDeSeguridad(userId) {
  if (!userId) return;
  __inicioSesion = new Date().toISOString();

  supa.channel("avisos-seguridad")
    .on("postgres_changes",
      { event: "INSERT", schema: "public", table: "avisos_usuario", filter: `user_id=eq.${userId}` },
      payload => { if (payload.new && payload.new.tipo === "cambio_password") mostrarCuentaRegresiva(); })
    .subscribe();

  // Un websocket dormido (portátil cerrado) pierde el evento: al volver a la
  // pestaña se consulta si quedó un aviso emitido durante esta sesión. La fila
  // se borra cuando el usuario completa el cambio, así que si existe, va en serio.
  document.addEventListener("visibilitychange", async () => {
    if (document.hidden || document.getElementById("aviso-seguridad")) return;
    try {
      const { data } = await supa.from("avisos_usuario")
        .select("id, tipo, creado_at")
        .eq("user_id", userId).eq("tipo", "cambio_password")
        .gte("creado_at", __inicioSesion)
        .limit(1);
      if (data && data.length) mostrarCuentaRegresiva();
    } catch { /* sin red: el realtime avisará al reconectar */ }
  });
}

async function cerrarYSalir() {
  // Primero se asegura el trabajo: lo pendiente de sincronizar viaja a la
  // nube (tope de 6s) antes de matar la sesión.
  try {
    await Promise.race([vaciarSincronizacionPendiente(), new Promise(r => setTimeout(r, 6000))]);
  } catch { /* se cierra igual */ }
  await anotarSalida("salida_seguridad");
  try { await supa.auth.signOut(); } catch { /* la recarga limpia el resto */ }
  location.reload();
}

function mostrarCuentaRegresiva() {
  if (document.getElementById("aviso-seguridad")) return;

  const tarjeta = document.createElement("div");
  tarjeta.id = "aviso-seguridad";
  tarjeta.style.cssText = `
    width:340px;max-width:calc(100vw - 32px);
    background:white;border:1px solid #fca5a5;border-left:4px solid ${C.red};
    border-radius:10px;box-shadow:0 12px 34px rgba(15,23,42,.25);padding:13px 14px;
    font-family:inherit;
  `;
  tarjeta.innerHTML = `
    <div style="display:flex;gap:9px;align-items:flex-start;">
      <div style="font-size:20px;line-height:1;">🔐</div>
      <div style="flex:1;min-width:0;">
        <div style="font-size:12.5px;font-weight:800;color:${C.text};">Debes cambiar tu contraseña</div>
        <div style="font-size:10.5px;color:${C.muted};margin-top:3px;line-height:1.45;">
          Un administrador lo exige. Guarda lo que estés haciendo: la sesión se
          cerrará en <b id="aviso-seguridad-reloj" style="color:${C.red};font-variant-numeric:tabular-nums;">3:00</b>
          y al volver a entrar se te pedirá la contraseña nueva. Lo que ya escribiste está guardado.
        </div>
        <div style="display:flex;gap:6px;margin-top:9px;">
          <button id="aviso-seguridad-salir" style="
            background:${C.red};color:white;border:none;border-radius:6px;
            padding:6px 12px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit;
          ">Cerrar sesión ahora</button>
        </div>
      </div>
    </div>
  `;
  anclarConEntrada(tarjeta, PRIORIDAD.seguridad);

  // El plazo se ancla a la hora de inicio, no a los tics: un temporizador con
  // la pestaña en segundo plano se ralentiza, pero Date.now() no miente.
  const limite = Date.now() + CUENTA_MS;
  const reloj = tarjeta.querySelector("#aviso-seguridad-reloj");
  const tic = setInterval(() => {
    const resta = Math.max(0, limite - Date.now());
    const m = Math.floor(resta / 60000);
    const s = Math.floor((resta % 60000) / 1000);
    if (reloj) reloj.textContent = `${m}:${String(s).padStart(2, "0")}`;
    if (resta <= 0) { clearInterval(tic); cerrarYSalir(); }
  }, 250);

  tarjeta.querySelector("#aviso-seguridad-salir").onclick = () => { clearInterval(tic); cerrarYSalir(); };
}
